import { render, staticRenderFns } from "./SelectFontes.vue?vue&type=template&id=67323f72"
import script from "./SelectFontes.vue?vue&type=script&lang=js"
export * from "./SelectFontes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports